import React from "react";
const Hexagon = ({ color, size, storeId, issue }) => (
  <div className="hexagon-wrapper">
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{ display: "block" }}
    >
      <polygon points="50,0 93,25 93,75 50,100 7,75 7,25" fill={color} />
    </svg>
   {issue ? <div className="tooltip">{issue}</div> : ''}
    
  </div>
);

export default Hexagon;
